import { Link } from 'react-router-dom';
import { Mascot } from './Mascot';
import { messageFor } from '@/lib/errors';

export const Spinner = () => (
  <span className="inline-block h-6 w-6 animate-spin rounded-full border-[3px] border-brand/25 border-t-brand" role="status" aria-label="Завантаження" />
);
export const FullLoader = () => <div className="grid min-h-[60vh] place-items-center"><Spinner /></div>;

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <div className="card mx-auto flex max-w-lg flex-col items-center gap-4 text-center" role="alert">
      <Mascot pose="think" className="h-32 w-auto" />
      <p className="text-lg font-extrabold">{messageFor(error)}</p>
      {onRetry && <button className="btn btn-sm" onClick={onRetry}>Спробувати ще раз</button>}
    </div>
  );
}
export function Empty({ text, action }: { text: string; action?: React.ReactNode }) {
  return <div className="rounded-3xl border-2 border-dashed border-line p-6 text-center font-bold text-ink-muted">{text}{action && <div className="mt-4">{action}</div>}</div>;
}
export function Forbidden({ text = 'Немає доступу до цієї сторінки.', title = 'Сюди не можна' }: { text?: string; title?: string }) {
  return (
    <div className="grid min-h-[70vh] place-items-center p-6">
      <div className="card flex max-w-md flex-col items-center gap-4 text-center">
        <Mascot pose="think" className="h-36 w-auto" />
        <h1 className="text-2xl font-black">{title}</h1>
        <p className="font-semibold text-ink-muted">{text}</p>
        <Link to="/" className="btn btn-sm">На головну</Link>
      </div>
    </div>
  );
}
export const NotFound = () => <Forbidden title="Сторінку не знайдено" text="Можливо, посилання застаріло або в ньому помилка." />;
